import Vue from 'vue/dist/vue.esm'

Vue.component("bar-chart-vue", () => import(/* webpackChunkName: "[request]" */ "components/BarChart.vue"))